<template>
	<v-container
		fluid
		fill-height
		class="d-flex align-center justify-center flex-1"
	>
		<v-card
			flat
			color="transparent"
			class="text-center"
			max-width="100vw"
		>
			<v-img
				src="../../../assets/logoarquimarket.png"
				contain
				max-width="140"
				class="mx-auto mb-6"
			/>

			<v-progress-circular
				indeterminate
				size="40"
				width="3"
				color="#524D4D"
				class="mb-6"
			/>

			<h3 class="mb-2">
				Estamos preparando tu espacio de trabajo
			</h3>

			<p class="grey--text text--darken-1">
				Por favor espera, estamos verificando tu acceso y cargando la información necesaria.
			</p>
		</v-card>
	</v-container>
</template>

<script>
export default {
  name: 'FullScreenLoader',
};
</script>
